import { components } from "types/declarations/api";

export type AcknowledgementPriceFormatType = components["schemas"]["AcknowledgementPriceFormat"];
export const AcknowledgementPriceFormat: Record<AcknowledgementPriceFormatType, AcknowledgementPriceFormatType> = {
	LIST: "LIST",
	NET: "NET",
	NET_MULTIPLIER: "NET_MULTIPLIER"
} as const;

export type AcknowledgmentEmailFormatType = components["schemas"]["AcknowledgmentEmailFormat"];
export const AcknowledgmentEmailFormat: Record<AcknowledgmentEmailFormatType, AcknowledgmentEmailFormatType> = {
	EXPANDED: "EXPANDED",
	CONDENSED: "CONDENSED"
} as const;

export type AvailabilityStatusType = components["schemas"]["AvailabilityStatus"];
export const AvailabilityStatus: Record<AvailabilityStatusType, AvailabilityStatusType> = {
	InStock: "InStock",
	LimitedStock: "LimitedStock",
	Backordered: "Backordered",
	OutOfStock: "OutOfStock"
} as const;

export type CabinetworksGroupApplicationType = components["schemas"]["CabinetworksGroupApplication"];
export const CabinetworksGroupApplication: Record<CabinetworksGroupApplicationType, CabinetworksGroupApplicationType> =
	{
		Tandem: "Tandem",
		Salesforce: "Salesforce"
	} as const;

export type CustomColorTypeType = components["schemas"]["CustomColorType"];
export const CustomColorType: Record<CustomColorTypeType, CustomColorTypeType> = {
	FinishSelect: "FinishSelect",
	ColorMatch: "ColorMatch",
	CustomColor: "CustomColor",
	Unknown: "Unknown"
} as const;

export type CustomQuoteStatusType = components["schemas"]["CustomQuoteStatus"];
export const CustomQuoteStatus: Record<CustomQuoteStatusType, CustomQuoteStatusType> = {
	Received: "Received",
	UnderReview: "UnderReview",
	Declined: "Declined",
	ReadyToOrder: "ReadyToOrder",
	Expired: "Expired"
} as const;

export type DraftTypeType = components["schemas"]["DraftType"];
export const DraftType: Record<DraftTypeType, DraftTypeType> = {
	Draft: "Draft",
	Template: "Template",
	Quote: "Quote",
	ShoppingCart: "ShoppingCart",
	ShoppingCartTemplate: "ShoppingCartTemplate"
} as const;

export type ImportOrderLineItemTypeType = components["schemas"]["ImportOrderLineItemType"];
export const ImportOrderLineItemType: Record<ImportOrderLineItemTypeType, ImportOrderLineItemTypeType> = {
	Cabinet: "Cabinet",
	CabinetCharge: "CabinetCharge",
	Accessory: "Accessory",
	AccessoryCharge: "AccessoryCharge"
} as const;

export type LanguagesType = components["schemas"]["Languages"];
export const Languages: Record<LanguagesType, LanguagesType> = {
	English: "English",
	Spanish: "Spanish"
} as const;

export type LeadAssignmentPreferenceType = components["schemas"]["LeadAssignmentPreference"];
export const LeadAssignmentPreference: Record<LeadAssignmentPreferenceType, LeadAssignmentPreferenceType> = {
	ByAdminsOnly: "ByAdminsOnly",
	ByAnyone: "ByAnyone"
} as const;

export type LeadAssignmentStatusType = components["schemas"]["LeadAssignmentStatus"];
export const LeadAssignmentStatus: Record<LeadAssignmentStatusType, LeadAssignmentStatusType> = {
	Assigned: "Assigned",
	Accepted: "Accepted",
	Declined: "Declined",
	Contacted: "Contacted",
	FollowUp: "FollowUp",
	Unresponsive: "Unresponsive",
	Quoted: "Quoted",
	Lost: "Lost",
	Sold: "Sold",
	Locked: "Locked"
} as const;

export type LogisticsModeType = components["schemas"]["LogisticsMode"];
export const LogisticsMode: Record<LogisticsModeType, LogisticsModeType> = {
	DIRECT: "DIRECT",
	CROSSDOCK: "CROSSDOCK"
} as const;

export type MerchandiseProductSortType = components["schemas"]["MerchandiseProductSort"];
export const MerchandiseProductSort: Record<MerchandiseProductSortType, MerchandiseProductSortType> = {
	Newest: "Newest",
	Oldest: "Oldest",
	PriceDecreasing: "PriceDecreasing",
	PriceIncreasing: "PriceIncreasing",
	NameAZ: "NameAZ",
	NameZA: "NameZA"
} as const;

export type OrderActionTypeType = components["schemas"]["OrderActionType"];
export const OrderActionType: Record<OrderActionTypeType, OrderActionTypeType> = {
	CancellationRequested: "CancellationRequested",
	EditRequested: "EditRequested",
	EditSuccessful: "EditSuccessful",
	EditFailed: "EditFailed",
	CancellationSuccessful: "CancellationSuccessful",
	CancellationDenied: "CancellationDenied",
	CreateReplacementOrder: "CreateReplacementOrder",
	CreateOriginalOrder: "CreateOriginalOrder",
	OrderCreated: "OrderCreated"
} as const;

export type OrderBusinessPurposeType = components["schemas"]["OrderBusinessPurpose"];
export const OrderBusinessPurpose: Record<OrderBusinessPurposeType, OrderBusinessPurposeType> = {
	REPAIR_REMODEL: "REPAIR_REMODEL",
	MULTI_FAMILY_APARTMENTS: "MULTI_FAMILY_APARTMENTS",
	NEW_CONSTRUCTION_SF: "NEW_CONSTRUCTION_SF",
	STOCK_ORDER: "STOCK_ORDER",
	UNKNOWN: "UNKNOWN"
} as const;

export type OrderCategoryType = components["schemas"]["OrderCategory"];
export const OrderCategory: Record<OrderCategoryType, OrderCategoryType> = {
	STOCK: "STOCK",
	QUICKSHIP: "QUICKSHIP",
	DOTCOM: "DOTCOM",
	SPECIAL: "SPECIAL",
	QUOTECENTER: "QUOTECENTER",
	OTHER: "OTHER"
} as const;

export type OrderStatusType = components["schemas"]["OrderStatus"];
export const OrderStatus: Record<OrderStatusType, OrderStatusType> = {
	UNKNOWN: "UNKNOWN",
	RECEIVED: "RECEIVED",
	SUBMITTED_WITH_ERRORS: "SUBMITTED_WITH_ERRORS",
	ACCEPTED: "ACCEPTED",
	CANCELLED: "CANCELLED",
	HOLD: "HOLD",
	SCHEDULED_FOR_PRODUCTION: "SCHEDULED_FOR_PRODUCTION",
	IN_PRODUCTION: "IN_PRODUCTION",
	PRODUCTION_COMPLETE: "PRODUCTION_COMPLETE",
	HEADED_TO_CROSS_DOCK: "HEADED_TO_CROSS_DOCK",
	EN_ROUTE_VIA_CARRIER: "EN_ROUTE_VIA_CARRIER",
	DELIVERED: "DELIVERED",
	INVOICED: "INVOICED",
	DELETED: "DELETED"
} as const;

export type OrderStatusReasonType = components["schemas"]["OrderStatusReason"];
export const OrderStatusReason: Record<OrderStatusReasonType, OrderStatusReasonType> = {
	MISSING_INFORMATION: "MISSING_INFORMATION",
	INCORRECT_PRICING: "INCORRECT_PRICING",
	ITEMS_ON_BACKORDER: "ITEMS_ON_BACKORDER",
	DELIVERY_DATE_CHANGED: "DELIVERY_DATE_CHANGED",
	PRODUCT_VALIDATION_HOLD: "PRODUCT_VALIDATION_HOLD",
	CUSTOMER_HOLD: "CUSTOMER_HOLD",
	PROCESSING_HOLD: "PROCESSING_HOLD",
	CREDIT_HOLD: "CREDIT_HOLD"
} as const;

export type OrderTypeType = components["schemas"]["OrderType"];
export const OrderType: Record<OrderTypeType, OrderTypeType> = {
	UNKNOWN: "UNKNOWN",
	ORIGINAL: "ORIGINAL",
	REPLACEMENT: "REPLACEMENT",
	ADD_ON: "ADD_ON",
	BACKORDER: "BACKORDER",
	CANCELLED: "CANCELLED",
	BILLING_ONLY: "BILLING_ONLY",
	ACCOMMODATION: "ACCOMMODATION",
	DISPLAY: "DISPLAY",
	SAMPLE: "SAMPLE",
	CUSTOM_COLOR: "CUSTOM_COLOR",
	QUOTE_ORDER: "QUOTE_ORDER",
	MERCH: "MERCH",
	CAMPAIGN: "CAMPAIGN"
} as const;

export type OriginType = components["schemas"]["Origin"];
export const Origin: Record<OriginType, OriginType> = {
	Unknown: "Unknown",
	Decade: "Decade",
	Oracle: "Oracle",
	Unidata: "Unidata",
	CWG: "CWG",
	Salesforce: "Salesforce"
} as const;

export type PriceTypeType = components["schemas"]["PriceType"];
export const PriceType: Record<PriceTypeType, PriceTypeType> = {
	Percentage: "Percentage",
	Fixed: "Fixed",
	Unknown: "Unknown"
} as const;

export type ShippingTypeType = components["schemas"]["ShippingType"];
export const ShippingType: Record<ShippingTypeType, ShippingTypeType> = {
	HOME_DELIVERY: "HOME_DELIVERY",
	CUSTOMER_PICKUP: "CUSTOMER_PICKUP",
	SMALL_PARCEL: "SMALL_PARCEL",
	SHIP_TO_STORE: "SHIP_TO_STORE",
	CANCELLED: "CANCELLED"
} as const;

export type TruckStatusType = components["schemas"]["TruckStatus"];
export const TruckStatus: Record<TruckStatusType, TruckStatusType> = {
	OPEN: "OPEN",
	IN_PRODUCTION: "IN_PRODUCTION",
	COMPLETE: "COMPLETE"
} as const;

export type UserChannelType = components["schemas"]["UserChannel"];
export const UserChannel: Record<UserChannelType, UserChannelType> = {
	DEALER: "DEALER",
	HOME_DEPOT: "HOME_DEPOT",
	LOWES: "LOWES",
	MENARDS: "MENARDS"
} as const;

export type UserNavigationGroupType = components["schemas"]["UserNavigationGroup"];
export const UserNavigationGroup: Record<UserNavigationGroupType, UserNavigationGroupType> = {
	STANDARD: "STANDARD",
	LOWES: "LOWES",
	MENARDS: "MENARDS",
	KRAFTMAID: "KRAFTMAID",
	MASTERPIECE: "MASTERPIECE",
	KRAFTMAID_MASTERPIECE: "KRAFTMAID_MASTERPIECE",
	HOME_DEPOT: "HOME_DEPOT",
	QUOTER: "QUOTER"
} as const;

export type UserPermissionType = components["schemas"]["UserPermission"];
export const UserPermission: Record<UserPermissionType, UserPermissionType> = {
	ADMIN: "ADMIN"
} as const;

export type UserRoleType = components["schemas"]["UserRole"];
export const UserRole: Record<UserRoleType, UserRoleType> = {
	UNKNOWN: "UNKNOWN",
	USER: "USER",
	CARE: "CARE",
	SALES: "SALES",
	QUOTER: "QUOTER",
	INTERNAL_DESIGNER: "INTERNAL_DESIGNER"
} as const;
